import fs from 'fs';
import matter from 'gray-matter';
import { GetStaticProps, NextPageWithLayout } from 'next';
import { MDXRemote } from 'next-mdx-remote';
import { serialize } from 'next-mdx-remote/serialize';
import remarkGfm from 'remark-gfm';

import { PageLayout } from '../../components/common/layout';
import { Text } from '../../components/ui';
import { markdownComponents } from '../../components/ui/text/markdown';
import { DeviceIntelligenceDetector } from '../../libs/sardine';
import { format } from '../../libs/utils/date';

const Terms: NextPageWithLayout = ({ source, frontMatter }) => {
  const updateDate = format(frontMatter.date, 'MMMM DD, YYYY');

  return (
    <>
      <div className="max-w-[700px] mx-auto">
        <Text variant="h1" className="pb-20">
          Terms of Use
        </Text>
        {frontMatter.date && (
          <Text variant="h4" className="pb-6">
            Last revised on: {updateDate}
          </Text>
        )}
        <MDXRemote {...source} components={{ ...markdownComponents }} />
      </div>
      <DeviceIntelligenceDetector />
    </>
  );
};

Terms.getLayout = (Component) => {
  return <PageLayout title="Terms">{Component}</PageLayout>;
};

export default Terms;

export const getStaticProps: GetStaticProps = async () => {
  const source = fs.readFileSync(
    process.cwd() + '/pages/terms/terms.md',
    'utf8',
  );

  const { content, data } = matter(source);
  const mdxSource = await serialize(content, {
    scope: data,
    // mdx.jsのAPIが利用できる https://github.com/hashicorp/next-mdx-remote#apis
    // remarkGfmでtableを書き換え
    mdxOptions: {
      remarkPlugins: [remarkGfm],
      rehypePlugins: [],
    },
  });
  return { props: { source: mdxSource, frontMatter: data } };
};
